// ============================================================
// role.js
// ------------------------------------------------------------
// ตรรกะของ "บทบาทผู้ใช้" (ชุดสิทธิ์) ที่หน้าเพิ่มและหน้าแก้ไขใช้ร่วมกัน
// เดิม CreateRole.js กับ UpdateRole.js เขียนตรรกะชุดนี้ซ้ำกันทั้งไฟล์
//
// รูปแบบข้อมูล
//   ในหน้าจอ  : permission เป็น boolean  { view: true, create: false, ... }
//   ที่ API    : permission เป็นข้อความ  { view: "true", create: "false", ... }
// เมนูทั้งหมดและค่าเริ่มต้นมาจาก global.role ใน components/global.js
// ============================================================

import "../config/global.js";

// สิทธิ์ที่แสดงเป็นคอลัมน์ในตาราง
export const PERMS = ["view", "create", "update", "delete"];

// สิทธิ์ทั้งหมดที่ส่งให้ API (มี approved ที่ไม่ได้แสดงบนหน้าจอ)
export const ALL_PERMS = [...PERMS, "approved"];

// คอลัมน์ของตารางสิทธิ์
export const ROLE_COLUMNS = [
  { id: "all", name: "ทั้งหมด" },
  { id: "view", name: "ดูข้อมูล" },
  { id: "create", name: "เพิ่มข้อมูล" },
  { id: "update", name: "แก้ไขข้อมูล" },
  { id: "delete", name: "ลบข้อมูล" },
];

// รายการเมนูเปล่า — คัดลอกจาก global.role เพื่อไม่ให้ไปแก้ตัวแปร global โดยตรง
export const emptyRoleDetail = () => JSON.parse(JSON.stringify(global.role));

// แปลงข้อมูลจากหน้าจอ → รูปแบบที่ API รับ (boolean → "true"/"false")
// ข้ามรายการที่ permission เป็น null (พวกหัวข้อกลุ่มเมนู)
export const toApiRoleDetail = (role_detail) =>
  role_detail
    .filter((e) => e.permission)
    .map((item) => {
      const permission = {};
      ALL_PERMS.forEach((k) => (permission[k] = String(!!item.permission[k])));
      return { menu_name: item.menu_name, permission };
    });

// แปลงข้อมูลจาก API → รูปแบบที่หน้าจอใช้ ("true" → true)
// เติมค่าลงบนโครงเมนูเปล่า เพื่อให้เมนูที่เพิ่มใหม่ทีหลังยังโผล่ครบ
//
// NOTE เมนูที่มีใน role_detail แต่ไม่มีใน global.role (เช่นเมนูของบทบาทเจ้าของระบบอย่าง
// project / receipt / invoice-by-room) ต้องเก็บต่อไว้ด้วย mark เป็น hidden
// ไม่งั้นกดบันทึกครั้งเดียวสิทธิ์พวกนี้จะหายไปเงียบ ๆ เพราะ toApiRoleDetail ส่งเฉพาะแถวที่อยู่ในโครง
export const fromApiRoleDetail = (fetched) => {
  const role_detail = emptyRoleDetail();
  const known = new Set(role_detail.filter((r) => r.permission).map((r) => r.menu_name));

  fetched.forEach((row) => {
    const match = role_detail.find((r) => r.permission && r.menu_name === row.menu_name);
    if (match) {
      ALL_PERMS.forEach((k) => (match.permission[k] = row.permission[k] === "true"));
      return;
    }
    if (known.has(row.menu_name)) return;

    const permission = {};
    ALL_PERMS.forEach((k) => (permission[k] = row.permission[k] === "true"));
    role_detail.push({ menu_name: row.menu_name, permission, hidden: true });
  });

  return role_detail;
};

// ติ๊กสิทธิ์
//   index = ตัวเลข → ติ๊กเฉพาะแถวนั้น (สลับค่าเดิม, ไม่สนใจ value)
//   index = null   → ติ๊กทั้งคอลัมน์ทุกแถว (ใช้ค่า value ที่ส่งมา)
//   type  = "all"  → ทำกับสิทธิ์ทุกตัวพร้อมกัน
export const toggleRolePermission = (role_detail, type, value, index = null) => {
  const next = [...role_detail];

  if (index !== null) {
    const permission = next[index].permission;
    if (type === "all") ALL_PERMS.forEach((k) => (permission[k] = !permission[k]));
    else permission[type] = !permission[type];
    return next;
  }

  next.forEach((row) => {
    if (!row.permission || row.hidden) return;
    if (type === "all") ALL_PERMS.forEach((k) => (row.permission[k] = value));
    else row.permission[type] = value;
  });
  return next;
};
